import React from 'react';

export default function MarginEnquiryTable() {
	return (
		<div className="table-view table-responsive">
			<table id="sales-quotes-charge-table" className="table">
				<thead>
					<tr>
						<th>Order Number</th>
						<th>Completed</th>
						<th>Warehouse</th>
						<th>Customer</th>
						<th>Product Code</th>
						<th>Product</th>
						<th>Quantity</th>
						<th>Cost</th>
						<th>Sell</th>
						<th>Charge</th>
						<th>Profit</th>
						<th>Margin</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
